import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";


@Injectable()
export class SignalREffects {

    constructor(
        private action$: Actions, 
        private store : Store
    ) {}

    
}